import {
  SharedModule,
  TypedBaseListComponent,
  DataService,
  ModalService,
  NotificationService,
} from "@bb-vendure/admin-ui/core";
import { Component, OnInit, Input } from "@angular/core";
import {
  CreateDefaultProductDescriptionTranslationDocument,
  DefaultProductDescriptionTranslationFilterParameter,
  DefaultProductDescriptionTranslationsDocument,
} from "src/generated-gql/graphql";
import { DefaultProductDescriptionTranslationDialogComponent } from "../dialog/dialog.component";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";

@Component({
  selector: "default-product-description-translation-list",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "list.component.html",
})
export class DefaultProductDescriptionTranslationListComponent
  extends TypedBaseListComponent<
    typeof DefaultProductDescriptionTranslationsDocument,
    "defaultProductDescriptionTranslations"
  >
  implements OnInit
{
  @Input() descriptionId?: string;
  @Input() dataTableId?: string;
  constructor(
    protected dataService: DataService,
    protected modalService: ModalService,
    protected notificationService: NotificationService
  ) {
    super();
    super.configure({
      document: DefaultProductDescriptionTranslationsDocument,
      getItems: result => result.defaultProductDescriptionTranslations,
      setVariables: (skip, take) => {
        const filterParams: DefaultProductDescriptionTranslationFilterParameter =
          {
            _and: [
              {
                title: {
                  contains: this.searchTermControl.value,
                },
              },
            ],
            ...this.filters.createFilterInput(),
          };
        if (this.descriptionId) {
          filterParams._and?.push({
            defaultProductDescriptionId: {
              eq: this.descriptionId,
            },
          });
        }
        return {
          options: {
            skip,
            take,
            filter: filterParams,
            sort: this.sorts.createSortInput(),
          },
        };
      },
      refreshListOnChanges: [
        this.sorts.valueChanges,
        this.filters.valueChanges,
      ],
    });
  }

  readonly filters = this.createFilterCollection()
    .addIdFilter()
    .addDateFilters()
    .addFilter({
      name: "Title",
      filterField: "title",
      type: {
        kind: "text",
      },
      label: "Value",
    })
    .connectToRoute(this.route);

  readonly sorts = this.createSortCollection()
    .defaultSort("id", "DESC")
    .addSorts([
      { name: "id" },
      { name: "title" },
      { name: "updatedAt" },
      { name: "createdAt" },
    ]);

  create() {
    this.modalService
      .fromComponent(DefaultProductDescriptionTranslationDialogComponent, {
        closable: true,
        size: "xl",
      })
      .subscribe(val => {
        this.dataService
          .mutate(CreateDefaultProductDescriptionTranslationDocument, {
            input: {
              ...val,
              languageCode: val.languageCode[0],
              defaultProductDescriptionId: this.descriptionId,
            },
          })
          .subscribe(({ createDefaultProductDescriptionTranslation }) => {
            if (createDefaultProductDescriptionTranslation.id)
              this.notificationService.success(
                _("common.notify-create-success"),
                {
                  entity: "Translation",
                }
              );
            this.refresh();
          });
      });
  }
}
